import { render, staticRenderFns } from "./CmgCheckoutOrderDetails.vue?vue&type=template&id=16da7f8e&scoped=true&lang=pug"
import script from "./cmg-checkout-order-details.ts?vue&type=script&lang=ts&external"
export * from "./cmg-checkout-order-details.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCheckoutOrderDetails.vue?vue&type=style&index=0&id=16da7f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16da7f8e",
  null
  
)

export default component.exports